import type {ListRepresentativesSearchInput} from "./list-representatives.schema";

import {keepPreviousData, useQuery} from "@tanstack/react-query";

import {listRepresentativesQueryOptions} from "./list-representatives.query-options";

export function useListRepresentatives(rawInput: ListRepresentativesSearchInput) {
  return useQuery({
    ...listRepresentativesQueryOptions(rawInput),
    placeholderData: keepPreviousData,
  });
}
